import * as React from "react";
import PropTypes from 'prop-types';

const SvgStore = props => {
  if (props.id !== "_svgstore") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 28 27" {...props}><g fill="none" fillRule="evenodd"><path d="M-10-11h48v48h-48z" /><path d="M25.783.75H2.217C.89.75 0 1.654 0 2.999v4.024c0 .986.565 1.783 1.4 2.1v14.115c0 1.26.872 2.012 2.333 2.012h1.4V13.39c0-1.31.873-2.225 2.123-2.225H20.6c1.334 0 2.267.884 2.267 2.15V25.25h1.75c1.427 0 1.983-.548 1.983-1.953V9.123c.835-.317 1.4-1.114 1.4-2.1V2.88c0-1.314-.85-2.13-2.217-2.13zm.817 6.273c0 .496-.328.828-.817.828H2.217c-.489 0-.817-.332-.817-.828V2.999c0-.558.267-.829.817-.829h23.566c.754 0 .817.351.817.71v4.143zM6.467 13.158c0-.336.097-.9.747-.9h6.253v14.185h-7V13.158zm14.436-.9c.41 0 .897.141.897.817v13.368h-7V12.258h6.103z" fill="#384048" /></g></svg>;
};

SvgStore.displayName = "_svgstore";
SvgStore.propTypes = {
  id: PropTypes.string
};
SvgStore.defaultProps = {
  id: ''
};
export default SvgStore;